export const SET_OCCUPATIONS = 'SET_OCCUPATIONS'
export const REFRESH_OCCUPATIONS = 'REFRESH_OCCUPATIONS'

export const ADD_OCCUPATION = 'ADD_OCCUPATION'
